import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";

export const useStyles = () => ({
    tab: css({
        minWidth: 0,
        padding: "10px 16px",
        marginRight: "16px",
        fontFamily: "roboto",
        fontSize: "16px",
        letterSpacing: "0.2px",
        opacity: 1,
        textTransform: "uppercase",
        color: Color.neutral[300],
        "&:hover": {
            borderBottom: `4px solid ${Color.primary[100]}`,
            paddingBottom: "6px"
        },
        "&.Mui-selected": {
            fontFamily: "roboto-bold",
            color: Color.primary[400]
        },
        "&.Mui-disabled": {
            opacity: 1,
            fontFamily: "roboto-medium",
            color: Color.neutral[500]
        }
    }),
    indicator: css({
        height: "4px",
        backgroundColor: Color.primary[400]
    })
});
